/**
 * @typedef {Object} Title
 * @property {string} primary
 * @property {string} secondary
 *
 * @typedef {Object} Presentation
 * @property {number|string} year
 * @property {Title} title
 * @property {string[]} with
 * @property {string} conference
 * @property {string} location
 * @property {string} format
 * @property {string} [type]
 */
/**
 * @type {Presentation[]}
 */
export const presentations = [
  {
    year: 2024,
    title: {
      primary:
        "Assessing learners' interactional competence through AI-generated speaking tasks",
      secondary: "",
    },
    with: [],
    conference: "IATEFL 2024 Conference",
    location: "Brighton, UK",
    format: "oral presentation",
    type: "teaching-oriented",
  },
  {
    year: 2024,
    title: {
      primary:
        "Enhancing EFL learners' pragmatic competence through web-based prosodic instruction",
      secondary: "",
    },
    with: [],
    conference: "AAAL 2024 Conference",
    location: "Houston, TX",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2024,
    title: {
      primary:
        "The Duolingo English Test: Using AI to revolutionize test development",
      secondary: "",
    },
    with: [],
    conference: "TESOL 2024 Convention",
    location: "Tampa, FL",
    format: "oral presentation",
    type: "teaching-oriented",
  },
  {
    year: 2023,
    title: {
      primary:
        "Exploring features of elaborate vs. compressed language in spoken academic discourse: An SEM approach.",
      secondary: "",
    },
    with: ["Goulart, L.", "Larsson, T."],
    conference: "44th ICAME onference",
    location: "Online",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2022,
    title: {
      primary: "Invited lecture on pragmatic features of spoken discourse",
      secondary: "",
    },
    with: [],
    conference:
      "Graduate seminar in Research Issues in English Language Teaching",
    location: "(Instructor: Dr. Romy Ghanem)",
    format: "In-person",
    type: "invited course lectures",
  },
  {
    year: 2022,
    title: {
      primary: "Invited lecture on L2 pragmatics and prosody",
      secondary: "",
    },
    with: [],
    conference: "Undergraduate seminar in language",
    location: "(Instructor: Dr. Okim Kang)",
    format: "In-person",
    type: "invited course lectures",
  },
  {
    year: 2019,
    title: {
      primary: "Invited lecture on teaching ESL/EFL abroad",
      secondary: "",
    },
    with: ["Wood, M."],
    conference: "Graduate seminar on professional development",
    location: "(Instructor: Dr. Fredricka Stoller)",
    format: "In-person",
    type: "invited course lectures",
  },
  {
    year: 2021,
    title: {
      primary: "Assessing L2 English learners' oral proficiency",
      secondary: "How to choose and administer elicited imitation tasks online",
    },
    with: ["Sudina, E."],
    conference: "Arizona TESOL conference",
    location: "(Online)",
    format: "oral presentation",
    type: "workshops",
  },
  {
    year: 2021,
    title: {
      primary: "Perceptions of accented English",
      secondary:
        "Promoting awareness of speaker variation and social justice in the ELT classroom",
    },
    with: ["Hirschi, K."],
    conference:
      "11th International Research Conference on Education, Language, and Literature (IRCEELT)",
    location: "(Online)",
    format: "oral presentation",
    type: "workshops",
  },
  {
    year: 2018,
    title: {
      primary: "How to design adaptable placement tests for adult ESL learners",
      secondary: "",
    },
    with: ["Campbell, D."],
    conference: "Arizona TESOL conference",
    location: "(Online)",
    format: "oral presentation",
    type: "workshops",
  },
  {
    year: 2022,
    title: {
      primary: "Pragma-prosodic variation in L2 learners' refusals",
      secondary: "",
    },
    with: ["Kang, O."],
    conference: "Pragmatics & Language Learning Conference",
    location: "(Online)",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2022,
    title: {
      primary: "I don't know but do you remember when...",
      secondary:
        "An analysis of keyword indicators of shifts in communicative purpose in conversational discourse units",
    },
    with: ["Keller, D."],
    conference:
      "15th International American Association for Corpus Linguistics Conference (AACL)",
    location: "Flagstaff, AZ",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2022,
    title: {
      primary:
        "Analysis of intonation patterns in naturalistic and elicited L1 and L2 spoken corpora",
      secondary: "",
    },
    with: ["Hirschi, K."],
    conference:
      "15th International American Association for Corpus Linguistics Conference (AACL)",
    location: "Flagstaff, AZ",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2023,
    title: {
      primary:
        "Fairness of Using Different English Accents in Listening Tasks of the Duolingo English Test",
      secondary: "",
    },
    with: ["Kang, O.", "Yan, X.", "Thomson, R.", "Isaacs, T."],
    conference: "Language Assessment Research Conference",
    location: "Chicago, IL.",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2023,
    title: {
      primary:
        "Shared-L1 effects in listening tasks of the Duolingo English Test: Test-takers' attitudes and score variance",
      secondary: "",
    },
    with: ["Kang, O.", "Yan, X.", "Thomson, R.", "Isaacs, T."],
    conference: "AAAL 2023 Conference",
    location: "Portland, OR.",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2024,
    title: {
      primary:
        "Study and scale quality in L2 speech perception: A methodological synthesis",
      secondary: "",
    },
    with: ["Sudina, K", "Baghlaf, E."],
    conference: "AAAL 2024 Conference",
    location: "Houston, TX.",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2024,
    title: {
      primary:
        "Linguistic features of compression and elaboration in spoken academic discourse: Exploring discipline and interactivity",
      secondary: "",
    },
    with: ["Goulart, L.", "Larsson, T."],
    conference: "44th ICAME Conference",
    location: "Online",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2022,
    title: {
      primary:
        "Listeners’ attitudes towards different English accents in high stakes listening tests",
      secondary: "",
    },
    with: ["Kang, O.", "Yan, X.", "Thomson, R.", "Isaacs, T."],
    conference:
      "Pronunciation in Second Language Learning and Teaching Conference (PSLLT)",
    location: "St. Catherines, ON, Canada",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2022,
    title: {
      primary:
        "Prosody of L1 and L2 English speakers' pragmatic production of high imposition requests and refusals",
      secondary: "",
    },
    with: [],
    conference: "AAAL 2022 Conference",
    location: "Pittsburgh, PA",
    format: "poster",
    type: "research",
  },
  {
    year: 2022,
    title: {
      primary:
        "Role of prosody in perceptions of politeness in L1 and L2 English requests and refusals",
      secondary: "",
    },
    with: [],
    conference: "AAAL 2022 Conference",
    location: "Pittsburgh, PA",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2022,
    title: {
      primary: "What does it mean to “search a cell phone?”",
      secondary: "",
    },
    with: ["Cunningham, C.", "Egbert, J.", "Black, A."],
    conference: "Annual Law & Corpus Linguistics Conference",
    location: "Provo, UT",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2021,
    title: {
      primary:
        "Describing the discourse of pandemic-focused Yelp reviews to find the new normal",
      secondary: "A keyword analysis",
    },
    with: ["Keller, D.", "Cavusoglu, M.", "Beloin, K."],
    conference: "Corpus Linguistics International Conference (CL2021)",
    location: "(Online)",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2021,
    title: {
      primary:
        "Identifying dimensions of keyword variation using Multiple Correspondence Analysis",
      secondary: "",
    },
    with: ["Keller, D.", "Cavusoglu, M.", "Beloin, K."],
    conference: "Corpus Linguistics International Conference (CL2021)",
    location: "(Online)",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2021,
    title: {
      primary: "Elicited Imitation Tasks as a Measure of L2 Proficiency",
      secondary: "A Meta-Analysis",
    },
    with: ["Plonsky, L."],
    conference: "AAAL 2021 Conference",
    location: "Pittsburgh, PA (Online)",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2020,
    title: {
      primary:
        "Explicit Prosodic Priming of Relative Clause Attachment Preferences in L1 and L2 English Speakers",
      secondary: "",
    },
    with: [],
    conference: "SLRF 2020",
    location: "Nashville, TN (Online)",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2021,
    title: {
      primary:
        "From Corpus to Classroom: Evaluating Web-based Tools to Teach Collocations",
      secondary: "",
    },
    with: ["Goulart, L."],
    conference: "AZ-CALL",
    location: "Phoenix, AZ (Online)",
    format: "oral presentation",
    type: "teaching-oriented",
  },
  {
    year: 2020,
    title: {
      primary:
        "Corpus-driven Investigation of Lexical Bundles in Online User-generated Reviews",
      secondary: "",
    },
    with: [],
    conference: "TESOL Convention Doctoral Forum",
    location: "Denver, CO (Online)",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2020,
    title: {
      primary:
        "Establishing a Writing Community Through Interactive Personal Blogs",
      secondary: "",
    },
    with: [],
    conference: "ASU 2020 Composition Conference",
    location: "Tempe, AZ",
    format: "oral presentation",
    type: "teaching-oriented",
  },
  {
    year: 2019,
    title: {
      primary:
        "Nine Activities to Enhance Writing Processes through Community Building",
      secondary: "",
    },
    with: ["Campbell, D."],
    conference: "TESOL Convention",
    location: "Atlanta, GA",
    format: "oral presentation",
    type: "teaching-oriented",
  },
  {
    year: 2019,
    title: {
      primary:
        "Designing Flexible Placement Tests for Adult English Language Learners",
      secondary: "",
    },
    with: ["Campbell, D."],
    conference: "TESOL Convention",
    location: "Atlanta, GA",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2018,
    title: {
      primary: "Pause, Inhale, Speak",
      secondary:
        "Meaningful Pauses to Improve ESL Instructors' Comprehensibility",
    },
    with: ["Campbell, D."],
    conference: "TESOL Convention Masters Forum",
    location: "Chicago, IL",
    format: "oral presentation",
    type: "teaching-oriented",
  },
  {
    year: 2018,
    title: {
      primary:
        "Pragmatics of Service Encounter Requests in English, German, and Russian",
      secondary: "",
    },
    with: [],
    conference:
      "Sixth International Conference on the Development and Assessment of Intercultural Competence",
    location: "Tempe, AZ",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2017,
    title: {
      primary: "Building Bonds",
      secondary: "Activities for Building Community in the Classroom",
    },
    with: ["Campbell, D."],
    conference: "AZTESOL Conference",
    location: "Tucson, AZ",
    format: "oral presentation",
    type: "teaching-oriented",
  },
  {
    year: 2017,
    title: {
      primary:
        "Eclectic and Adaptable Vocabulary Practices in the Second Language Classroom",
      secondary: "",
    },
    with: ["Campbell, D."],
    conference: "AZTESOL/GSAAL Conference",
    location: "Flagstaff, AZ",
    format: "oral presentation",
    type: "teaching-oriented",
  },
  {
    year: 2017,
    title: {
      primary:
        "Task Factors Influencing Complexity, Accuracy, and Fluency in Oral L2 Production",
      secondary: "",
    },
    with: [],
    conference: "PEAKS Interdisciplinary Conference",
    location: "Flagstaff, AZ",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2016,
    title: {
      primary: "Analysis of Service Encounter Requests in Russian and German",
      secondary: "",
    },
    with: [],
    conference: "BAELc5, Bonn Applied English Linguistics Conference",
    location: "Bonn, Germany",
    format: "oral presentation",
    type: "research",
  },
  {
    year: 2015,
    title: {
      primary: "The Question of Standards in Higher Education",
      secondary: "",
    },
    with: [],
    conference: "Russian International Studies Association Convent",
    location: "Moscow, Russia",
    format: "oral presentation",
    type: "research",
  },
];

const sortPresentationsByType = (type) => {
  switch (type) {
    case "research":
      return 9999;
    case "teaching-oriented":
      return 9998;
    case "workshops":
      return 9997;
    case "invited course lecture":
      return 9996;
    default:
      return 9995;
  }
};

export const sortPresentations = (a, b) => {
  return (
    sortPresentationsByType(b.type) - sortPresentationsByType(a.type) ||
    b.year - a.year
  );
};

export default presentations;
